import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';
import { lazy } from 'react';

const Invoices = lazy(() => import('../pages/invoices/Invoices'));

const invoicesRoutes = (
    <Route path="invoices">
        <Route
            index
            element={
                <ProtectedRoute requiredPermission="invoices_list">
                    <Invoices />
                </ProtectedRoute>
            }
        />
    </Route>
);

export default invoicesRoutes;
